import React from 'react';
import { Link } from 'react-router-dom';
import './GHPCertificate.css';

const GHPCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Quality Certification</div>
            <h1 className="page-title">GHP Certificate (Good Hygiene Practices)</h1>
            <div className="page-text-content">
              <p>
                Food industry carries the responsibility of providing consumers with reliable and 
                healthy products. Therefore, adhering to hygiene standards and ensuring the safety 
                of production processes is of great importance. The "GHP Certificate Good Hygiene 
                Practices" stands out as a milestone in this regard. The GHP Certificate, among the 
                professional services we offer as NQC (Nova Quality Certification Agency), enables 
                businesses to achieve high standards in hygiene and safety.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is the GHP Certificate?</h2>
            <div className="page-text-content">
              <p>
                GHP, abbreviated from "Good Hygiene Practices," certifies compliance with hygiene 
                standards in food production and processing processes. This certificate helps 
                businesses to gain consumer confidence by ensuring production under hygienic conditions.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What are Good Hygiene Practices (GHP) for the GHP Certificate?</h2>
            <div className="page-text-content">
              <p>
                The GHP Certificate verifies compliance with cleanliness, safety, and quality 
                standards in all stages of production processes. Good Hygiene Practices aim to ensure 
                that businesses adhere to hygiene standards at every stage of production and maintain 
                product safety. The GHP Certificate establishes standards in various areas, including:
              </p>
            </div>
            <div className="practices-list">
              <div className="practice-item">
                <h3 className="practice-title">1. Personnel Hygiene</h3>
                <p className="practice-description">
                  Compliance of employees with cleanliness standards and adherence to hygiene rules.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">2. Facility Hygiene</h3>
                <p className="practice-description">
                  Ensuring production facilities are clean and hygienic, including regular cleaning 
                  and disinfection processes.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">3. Production Equipment</h3>
                <p className="practice-description">
                  Regular maintenance, cleaning, and sterilization of production equipment.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">4. Raw Material Control</h3>
                <p className="practice-description">
                  Control of raw materials and ingredients to meet hygiene standards.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">5. Product Traceability</h3>
                <p className="practice-description">
                  Traceability of production stages and proper labeling of products.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">6. Training Programs</h3>
                <p className="practice-description">
                  Providing regular hygiene training to employees.
                </p>
              </div>
              <div className="practice-item">
                <h3 className="practice-title">7. Risk Analysis and HACCP Applications</h3>
                <p className="practice-description">
                  Analysis of hygiene risks and compliance with Hazard Analysis and Critical Control 
                  Points (HACCP) principles.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of GHP Certificate for Businesses:</h2>
            <div className="page-text-content">
              <p>
                Having the GHP Certificate offers several advantages to businesses:
              </p>
            </div>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Consumer Confidence</h3>
                <p className="advantage-description">
                  The GHP Certificate demonstrates a business's commitment to product safety, 
                  fostering consumer trust.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Competitive Advantage</h3>
                <p className="advantage-description">
                  Setting businesses apart from competitors in the industry.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Ease of International Trade</h3>
                <p className="advantage-description">
                  Facilitating acceptance of products in international markets and expanding trade 
                  opportunities.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Improvement in Hygiene Standards</h3>
                <p className="advantage-description">
                  Guiding businesses in improving hygiene standards and encouraging continuous 
                  improvement.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">5. Legal Compliance</h3>
                <p className="advantage-description">
                  Reducing legal risks by complying with food safety and hygiene regulations.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Conclusion</h2>
            <div className="page-text-content">
              <p>
                The GHP Certificate for Good Hygiene Practices is an important document aimed at 
                helping businesses comply with hygiene standards in food production and processing 
                processes. With the professional services provided by NQC (Nova Quality Certification 
                Agency), we guide businesses in obtaining the GHP Certificate. This certificate not 
                only ensures compliance with hygiene standards but also helps businesses gain customer 
                confidence and become successful brands. For businesses aiming to lead in hygiene, 
                safety, and quality, the GHP Certificate is a valuable tool with significant advantages.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default GHPCertificate;

